/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import ClipboardJS from "clipboard"

Buyapowa.Views.ClipboardButton = class ClipboardButton {
  constructor(el, successNotification, errorNotification, overlayedElement) {
    this.el = el;
    this.overlayedElement = overlayedElement;
    this.el.on("click", event => event.preventDefault());

    const client = new ClipboardJS(this.el.get(0));

    client.on("success", event => {
      if (successNotification != null) {
        this._showNotification(successNotification);
      }

      const eventTrigger = $(event.trigger);
      if (eventTrigger.hasClass("input-append")) {
        this._showTickIcon(eventTrigger);
      }

      if (eventTrigger.data("track-method")) {
        window[eventTrigger.data("track-method")]();
      }

      return this.el.parent().find("[data-announcement]").text(this.el.data("success-message"));
    });

    client.on("error", event => {
      if (errorNotification != null) {
        return this._showNotification(errorNotification);
      } else {
        return this._showTooltip(event.trigger, event.action);
      }
    });
  }

  _showTooltip(element, action) {
    $('#' + $(element).data('selector')).remove();
    $(element).parent().find("input[type=text]").select();
    $(element).attr('title', this._copyHelpText(element));
    $(element).foundation('tooltip');
    return Foundation.libs.tooltip.showTip($(element));
  }

  _copyHelpText(element) {
    if (/iPhone|iPad/i.test(navigator.userAgent)) {
      return $(element).data('copy-message-mobile');
    } else if (/Mac/i.test(navigator.userAgent)) {
      return $(element).data('copy-message-mac');
    } else {
      return $(element).data('copy-message-generic');
    }
  }

  _successMessage(element) {
    return $(element).data("success-message");
  }

  _showTickIcon(element) {
    element.addClass("success");
    return element.find("i").attr("class", "fi-check");
  }

  _showNotification(notification) {
    if (this.overlayedElement) {
      const position = this.overlayedElement.position();
      const width = this.overlayedElement.outerWidth();
      notification.css({
        top: position.top,
        left: position.left,
        width
      });
    }

    notification.css({display: "flex"});
    notification.delay(1000).fadeOut(500);
    return notification.parent().find("[data-announcement]").text(notification.data("message"));
  }
};
